import * as emailValidator from '@rategravity/core-lib/validate-email';
import React from 'react';
import Card from '../components/card';
import SessionCard from '../components/card/session-card';
import { TextField } from '../components/MaskedTextField';
import hubspot from '../modules/hubspot';
import styles from '../styles/form';
import { BorrowerCard } from './card-lenses';

/**
 * ScenarioType = 'Affordability' | 'Preapproval' | 'RefiFull' |
 * 'RefiQualify' | 'Qualify' | 'Purchase';
 *
 * @param { ScenarioType } scenario
 */
const getHeaderContext = (scenario) => {
  switch (scenario) {
    case 'Affordability':
      return 'home financing ';
    case 'Preapproval':
      return 'pre-approval ';
    case 'Purchase':
      return 'mortgage ';
    case 'RefiFull':
    case 'RefiQualify':
      return 'refinancing ';
    default:
      return '';
  }
};

/**
 * ScenarioType = 'Affordability' | 'Preapproval' | 'RefiFull' |
 * 'RefiQualify' | 'Qualify' | 'Purchase';
 *
 * @param { ScenarioType } scenario
 */
const getBodyContext = (scenario) => {
  switch (scenario) {
    case 'Affordability':
      return 'affordability ';
    case 'Preapproval':
      return 'pre-approval ';
    case 'Purchase':
      return 'financing ';
    case 'RefiFull':
    case 'RefiQualify':
      return 'refinancing rate ';
    default:
      return '';
  }
};

/**
 * @param model A representation of the state (see: stateContainer).
 *   Because this component is immediately wrapped with the
 *   BorrowerCard CardLense, the particular model this component
 *   receives is an Immutable Map for the borrower. Moreover,
 *   the onChange function that is passed in has its first
 *   argument (modelKey) bound to "borrower".
 * @param onChange Function with the following parameters:
 *   @param key Key on the second level (e.g. "creditAgree" on loan)
 *   @param val The new value for the key.
 */
const Email = ({ model, scenario, onChange, onSubmit, last, ...cardProps }) => (
  <Card
    buttonType={last ? 'complete' : undefined}
    title={`You're on your way to a better ${getHeaderContext(scenario)}experience!`}
    onSubmit={
      onSubmit &&
      (() => {
        hubspot.identifyContact(model.get('email'));
        onSubmit();
      })
    }
    {...cardProps}
  >
    <br />
    <strong>No spam, ever.</strong> We&apos;ll never sell or share your email address. We use email
    to to send important communications related to your {getBodyContext(scenario)}request. You can
    opt-out of emails from us at any time.
    <TextField
      className="private"
      value={model.get('email')}
      style={styles.fullWidth}
      validate={(value) => {
        return !emailValidator.validate(value) ? 'Please enter a valid email' : '';
      }}
      floatingLabelText="Email Address"
      onChange={(v) => onChange('email', v.trim())}
    />
  </Card>
);

export const PrimaryBorrowerEmail = (last = true) =>
  SessionCard(
    BorrowerCard(Email, 'BorrowerEmail', { last }, ({ model }) =>
      emailValidator.validate(model.get('email') || '')
    )
  );



// WEBPACK FOOTER //
// ./src/cards/email.js